/**
 *
 * Asynchronously loads the component for SigninPage
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
